<template>
  <div class="timeline-item prev">
    <div class="item-badge" @click="goToPreviousStep">{{ index + 1 }}</div>
    <div class="item-content">
      <h2>{{ step.caption }}</h2>
      <div class="btn-group btn-group-vertical radio-group">
        <div class="radio-button btn">
          <input type="radio" class="radio-button__input active" checked>
          <label class="radio-button__label radio-text">
            {{ chosenValue?.caption }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useWizardStepsStore } from "../store/wizardStepsStore";

const props = defineProps<{
  step: Step,
  index: number
}>();

const store = useWizardStepsStore();
const chosenValue = props.step.subItems.find((subItem) => subItem.id === props.step.chosenValue);

const goToPreviousStep = () => {
  // remove all steps after the clicked one and set it as active
  store.currentStep = props.step;

  const index = store.previousSteps.findIndex((step) => step.id === props.step.id);
  if (index !== -1) {
    store.previousSteps = store.previousSteps.slice(0, index);
  }
}
</script>